import { Component, inject, input } from "@angular/core";
import type { HeaderRendererColumn } from "../data-grid/header-renderer.interface";
import { TrainingDataService } from "./training-data.service";

// Mirrors DefaultCellRendererComponent, but highlights the cell when its column is the selected content column.
@Component({
  template: `<p class="cell-text p-text-footnote p-color-text-secondary">{{value()}}</p>`,
  styles: [
    `.cell-text { display: block; min-width: 0; flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
     :host-context(.cell-zoom-content) { overflow: visible !important; }
     :host-context(.cell-zoom-content) .cell-text { overflow: visible; overflow-wrap: anywhere; text-overflow: clip; white-space: normal; }
     :host.highlightCol { background-color: var(--p-color-blue-100); }`,
  ],
  host: {
    // .p-table-cell is a flex row that centers items rather than stretching them, so the host must
    // opt into filling the cell's full width/height itself for the highlight background to cover it.
    // The negative margin/padding pair bleeds the host out through .p-table-cell's own padding so the
    // highlight reaches the cell's edges, while keeping the text inset by the same amount as before.
    style:
      "display: flex; align-items: center; align-self: stretch; flex: 1 1 auto; min-width: 0; overflow: hidden; " +
      "box-sizing: border-box; margin: calc(-1 * var(--p-spacing-xs)); padding: var(--p-spacing-xs);",
    "[class.highlightCol]": "isContentCol()",
  },
})
export class TrainingDataCellRendererComponent {
  private service = inject(TrainingDataService);

  readonly value = input<string>();
  readonly column = input<HeaderRendererColumn>();

  isContentCol(): boolean {
    const column = this.column();
    return !!(column && this.service.contentCol && column.prop === this.service.contentCol.colId);
  }
}
